import VerificationTemplateTableConfig from './VerificationTemplateTableConfig';

const columns = (t) => {
  return [
    {
      field: 'companyName',
      label: 'Firma',
      sort: 'desc',
      width: 53,

    },
    ...VerificationTemplateTableConfig(t),
  ];
};

export default columns;
